import { theme } from 'antd';
import { DeviceGroupsIcon } from 'assets/images/svg';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAssetGroupsByDeviceID } from 'reduxStore/assetGroups/selectors';
import { Loader } from 'zComponents/atoms';
import DeviceGroupsDrawer from 'zComponents/molecules/DeviceGroupDrawer';
import { Empty, Flex, Tag } from 'zui/Antd';

const DevicesGroupPanelContent = ({ deviceID }) => {
	const {
		token: { fontWeightStrong, paddingSM, paddingXXS }
	} = theme.useToken();

	// ✅ Redux state
	const groups = useSelector((state) => selectAssetGroupsByDeviceID(state, deviceID));

	const [openDeviceGroupModal, setOpenDeviceGroupModal] = useState(false);
	const [selectedDeviceGroupID, setSelectedDeviceGroupID] = useState(null);

	const { loadingAddGroupAsset, loadingDeleteGroupAsset } = useSelector((state) => state.AssetGroups);

	return (
		<Flex wrap gap={paddingSM}>
			{loadingAddGroupAsset || loadingDeleteGroupAsset ? (
				<Flex
					justify='center'
					align='center'
					style={{
						width: '100%'
					}}
				>
					<Loader />
				</Flex>
			) : groups.length === 0 ? (
				<div
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center'
					}}
				>
					<Empty description='No device groups' image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</div>
			) : (
				groups?.map((group) => (
					<Tag
						key={group.groupID}
						color='blue'
						style={{
							fontWeight: fontWeightStrong,
							borderColor: 'currentColor',
							cursor: 'pointer',
							marginInlineEnd: 0
						}}
						onClick={() => {
							setSelectedDeviceGroupID(group?.groupID);
							setOpenDeviceGroupModal(true);
						}}
					>
						<Flex align='center' gap={paddingXXS}>
							<DeviceGroupsIcon color='currentColor' />
							{group.name}
						</Flex>
					</Tag>
				))
			)}
			<DeviceGroupsDrawer
				groupID={selectedDeviceGroupID}
				setVisible={setOpenDeviceGroupModal}
				visible={openDeviceGroupModal}
			/>
		</Flex>
	);
};

export default DevicesGroupPanelContent;
